export const project = 'shiftDr'; // need this for when we dynamically import utils

export const sending = ({ win, data, preview }) => {
	const objectToReturn = {
		data: {
			event: data.events,
			payload: {
				digRet: data.digRet
			}
		},
		sender: 'sd'
	};

	if (!preview && win.sd) {
		win.sd('dataLayer', data);
		win.sd('send');
	}

	return {
		payloads: [objectToReturn]
	};
};

export const vehicleStatus = ({ vehicles }) => {
	const vehicle = vehicles[0];
	if (vehicle.newOrUsed.toUpperCase() === 'NEW') {
		return 'New';
	} else if (vehicle.newOrUsed.toUpperCase() === 'USED') {
		if (vehicle.certified.toUpperCase() === 'CERTIFIED') {
			return 'CPO';
		} else {
			return 'Used';
		}
	} else {
		return '';
	}
};
